import React from 'react'
import { useEffect, useState } from 'react';
import "./Packages.css"
import { Container } from 'react-bootstrap'
import { Card, Title } from '../../../../components'
import { Splide, SplideSlide } from "@splidejs/react-splide";
import image1 from "../../../../assets/images/home/packages/1.png";
import image2 from "../../../../assets/images/home/packages/2.png";
import image3 from "../../../../assets/images/home/packages/3.png";
import image4 from "../../../../assets/images/home/packages/4.png";
import StaticImage from "../../../../assets/images/package-img-default.png"
import { axiosGet } from '../../../../utils/apis/api'; 
import { Link } from 'react-router-dom';



const Packages = ({ pageData, url }) => {

    const packageData = pageData?.templates?.find(template => template.section === "Packages");
    const { packages_title, packages_subtitle, packages_desc } = packageData?.data || {};
    const [packagesData, setPackagesData] = useState([]);
    const [isLoading, setIsLoading] = useState(false);

    // const packagesData = [
    //     {image: image1, title: 'Chiang Mai', location: 'Thailand', price: '400', days: '3', rate: '4.5'},
    //     {image: image2, title: 'Chiang Mai', location: 'Thailand', price: '400', days: '3', rate: '4.5'},
    //     {image: image3, title: 'Chiang Mai', location: 'Thailand', price: '400', days: '3', rate: '4.5'},
    //     {image: image4, title: 'Chiang Mai', location: 'Thailand', price: '400', days: '3', rate: '4.5'},
    //     {image: image3, title: 'Chiang Mai', location: 'Thailand', price: '400', days: '3', rate: '4.5'},
    //     {image: image4, title: 'Chiang Mai', location: 'Thailand', price: '400', days: '3', rate: '4.5'},
    //     {image: image2, title: 'Chiang Mai', location: 'Thailand', price: '400', days: '3', rate: '4.5'},
    //     {image: image1, title: 'Chiang Mai', location: 'Thailand', price: '400', days: '3', rate: '4.5'},
    // ]

    const formatDurationToDays = (seconds) => {
      if (!seconds || seconds <= 0) return "";   
      const days = Math.floor(seconds / 86400);
      return `${days} day${days !== 1 ? "s" : ""}`;
    };

    const fetchPackages = async () => {
    try {
      const apiUrl = `${url}/api/method/alltimes.www.api.get_top_packages`;

      setIsLoading(true);
      const response = await axiosGet(apiUrl); 
      const result = response.message;

      setPackagesData(result || []);
      setIsLoading(false);
    } catch (error) {
      console.error("Failed to fetch top packages:", error.message);
      setIsLoading(false);
    }
  };

  useEffect(() => {
    fetchPackages();
  }, []);
  return (
    <div className="packages-container">
      <Container className="package-content">
        <Title
          desc={packages_subtitle}
          title={packages_title}
          para={packages_desc}
        />
      </Container>
      <div className="packages-slider">
        <Splide
          options={{
            type: "loop",
            arrows: true,
            pagination: true,
            gap: "30px",
            autoWidth: true,
            perPage: 3,
            // perMove: 3,
          }}
        >
          {packagesData.map((item, index) => {
            return (
              <SplideSlide key={index}>
                <Link
                  to={`/package/${encodeURIComponent(item.name)}`}
                  style={{ textDecoration: "none" }}
                >
                  <Card
                    image={
                      item.gallery
                        ? encodeURI(`${url}${item.gallery}`)
                        : StaticImage
                    }
                    title={item.package_name}
                    location={item.destination_name}
                    price={item.price}
                    currency={item.currency}
                    symbol={item.currency_symbol}
                    days={formatDurationToDays(item.duration)}
                    // rate={item.rate}
                  />
                </Link>
              </SplideSlide>
            );
          })}
        </Splide>
      </div>
    </div>
  );
}

export default Packages